<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ToggleSwitch from '@/components/Interface/ToggleSwitch/ToggleSwitch.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import { computed } from 'vue'

const playerFlagsStore = usePlayerFlagsStore()

const isTutorialDisabled = computed(() => {
  return playerFlagsStore.getFlag('tutorial_disable_tutorial') === 'true'
})

// Toggle handler for tutorial disable
const handleTutorialToggle = async () => {
  const newValue = isTutorialDisabled.value ? 'false' : 'true'
  await playerFlagsStore.setFlag('tutorial_disable_tutorial', newValue)
}
</script>

<template>
  <StandardCard title="Help">
    <div class="flex justify-between items-center">
      <div>
        Disable the help/tutorial popups
      </div>
      <div class="flex items-center pb-1">
        <ToggleSwitch
          :modelValue="isTutorialDisabled"
          @update:modelValue="handleTutorialToggle"
        />
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>